import {
  RemoteChildDataSource,
  RemoteChildDataSourceOptions
} from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { RemoteListChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteListChildDataSource";
import { RemoteOneChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteOneChildDataSource";
import { action, observable } from "mobx";
import { CommonError } from "lego-gui-lib";

export class EntriesDataSource<T, ID> extends RemoteChildDataSource<T, ID> {
  public static create<T, ID>(
    options: RemoteChildDataSourceOptions
  ): RemoteChildDataSource<T, ID> {
    const it = new EntriesDataSource<T, ID>(options);

    it.listDataSource = new EntriesListDataSource(options);
    it.oneDataSource = new RemoteOneChildDataSource({ ...options });

    return it;
  }
}

export class EntriesListDataSource<T, ID> extends RemoteListChildDataSource<
  T,
  ID
> {
  @action
  public async uploadFileWithEntries(file: {}): Promise<void> {
    try {
      await this.api.fileUpload(`${this.url}`, { file: file });
    } catch (e) {
      this.commons.newError(e.response.data as CommonError);
    }
  }
}
